// extracted by mini-css-extract-plugin
export var embed = "EmbedModal-module--embed--3f41c";
export var hiddenInfo = "EmbedModal-module--hiddenInfo--b4998";
export var instagram = "EmbedModal-module--instagram--88e90";
export var modalContent = "EmbedModal-module--modalContent--882c2";
export var tiktok = "EmbedModal-module--tiktok--fcbbf";